import React, {useContext} from 'react';
import {NavLink} from "react-router-dom";
import Icon from "@mdi/react";
import {mdiMemoryArrowDown, mdiLogoutVariant, mdiChessQueen, mdiChartLine } from "@mdi/js";
import classes from './Sidebar.module.scss';
import {observer} from "mobx-react-lite";
import {Context} from "../index";
import logo from "../assets/logo.png";
import {AUTH_ROUTE, THINGS_ROUTE} from "../utils/consts";


const Sidebar = observer(() => {
    const {user} = useContext(Context)
    return (
        <aside className={classes.wrapper}>
            <div className={classes.top}>
                <img className={classes.logo_img} src={logo} alt=""/>
            </div>
            <nav className={classes.sidebar}>
                <div className={classes.navbar}>
                    <NavLink className={({isActive}) => isActive ? classes.active : classes.link}
                             to={THINGS_ROUTE}><Icon
                        size={1} path={mdiMemoryArrowDown}/><h3>Устройства</h3></NavLink>
                    {/*<NavLink className={({isActive}) => isActive ? classes.active : classes.link}*/}
                    {/*         to={'analytics'}><Icon*/}
                    {/*    size={1} path={mdiChartLine}/><h3>Аналитика</h3></NavLink>*/}
                    {/*<NavLink className={({isActive}) => isActive ? classes.active : classes.link}*/}
                    {/*         to={'admin'}><Icon*/}
                    {/*    size={1} path={mdiChessQueen}/><h3>Admin</h3></NavLink>*/}
                </div>
                <div className={classes.logout}>
                    <NavLink className={({isActive}) => isActive ? classes.active : classes.link} to={AUTH_ROUTE}
                             onClick={() => {
                                 user.setIsAuth(false);
                                 localStorage.removeItem('token')
                             }}><Icon size={1} path={mdiLogoutVariant}/><h3>Выход</h3></NavLink>
                </div>
            </nav>
        </aside>
    );
});

export default Sidebar;